import { jsxs, jsx } from "react/jsx-runtime";
import { VoiceBlob } from "./Blob/index.js";
const BLOB_SIZE = 100;
const DOCK_HEIGHT = 130;
const DOCK_FADE_MASK = "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.7) 50%, #000 90%, #000 100%)";
const VoiceBottomDock = ({ blobState }) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2,
        height: DOCK_HEIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none"
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            "aria-hidden": true,
            style: {
              position: "absolute",
              inset: 0,
              background: "var(--color-background, #FFFFFF)",
              WebkitMaskImage: DOCK_FADE_MASK,
              maskImage: DOCK_FADE_MASK
            }
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              position: "relative",
              zIndex: 1,
              width: BLOB_SIZE,
              height: BLOB_SIZE,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ jsx(VoiceBlob, { state: blobState, size: BLOB_SIZE })
          }
        )
      ]
    }
  );
};
export {
  VoiceBottomDock
};
//# sourceMappingURL=VoiceBottomDock.js.map
